import { useMutation, useQueryClient } from "@tanstack/react-query";
import { operations } from "../openapi/generated-types.ts";
import { register } from "../openapi/api-client.ts";

export const useRegister = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      body: operations["registration.write.register"]["requestBody"]["content"]["application/json"],
    ) => {
      return register(body, {});
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ["events"],
        }),
      ]);
    },
  });
};
